import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function confirmPeraBulkCloseOutRequest(decodedResults: string[], cids: number[]) {
  try {
    const address = ParcisionCookies.get("address");
    const variables = {
      decodedResults,
      cids,
      address,
    };

    const query = gql`
      query MyQuery($decodedResults: [String!]!, $cids: [Float!]!, $address: String!) {
        confirmPeraBulkCloseOutRequest(decodedResults: $decodedResults, cids: $cids, address: $address) {
          message
        }
      }
    `;

    const data = await getQuery(query, variables);

    // @ts-expect-error
    return data.confirmPeraBulkCloseOutRequest;
  } catch (error) {
    toast.error("Failed to confirm closing out contract");
    sentryWrappedException(error);
    throw error;
  }
}
